import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
          <div className="logo">
            <img src={logo} alt="Exam Guide Home Tuitions" className="logo-image" />
          </div>
            <p>Connecting Parents and Tutors for Academic Success</p>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><HashLink smooth to="#home">Home</HashLink></li>
              <li><HashLink smooth to="#about">About Us</HashLink></li>
              <li><HashLink smooth to="#register-parent">Register as Parent</HashLink></li>
              <li><HashLink smooth to="#register-tutor">Register as Tutor</HashLink></li>
              <li><HashLink smooth to="#contact">Contact</HashLink></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h3>Contact Info</h3>
            <p><i className="fas fa-map-marker-alt"></i>12-5-3, MadhuraHouse, Vijayapuri Colony, lalaput road, Tarnaka</p>
            <p><i className="fas fa-phone-alt"></i>+91 7816088532</p>
            <p><i className="fas fa-envelope"></i> support@examguidetutorials.com</p>
          </div>
          
          <div className="footer-social">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/186ffqepzu/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/examguide_hometuitions?igsh=MWt3azZnZnhkNDRtcQ==" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://youtube.com/@examguidetutorials?si=4RF--sYlLUBpYAGa" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; 2025 Exam Guide. All Rights Reserved.</p>
          </div>
          <div className="admin-link">
            <Link to="/admin/login">Admin Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 